import { useGet } from '../../../sharedModules/hooks/useQuery';
import { CollectionClient } from '../model';

export const CANDIDATES_URL = '/collections/candidates';

export const collectionCandidatesQueryKey = (location: string) => [CANDIDATES_URL, { location }] as const;

export function useCollectionClients(location: string, enabled = true) {
  return useGet<CollectionClient[]>({
    url: CANDIDATES_URL,
    params: { location },
    enabled,
  });
}
